import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class LoginService {

	constructor(
		private http: HttpClient,
	) {
	}

	authenticate(settings: any) {
		// return this.http.post(`${settings.env.apiLoginUrl}v1/security/token`, 'grant_type=password&username=eclesial%40theos.com.br&password=789852'); // AMBIENTE QA
		// return this.http.post(`${settings.env.apiLoginUrl}v1/security/token`, 'grant_type=password&username=wander%40admtheos.com.br&password=wwm@1520'); // AMBIENTE QA
		// return;
	}

	getConfigNomenclatura(settings: any) {
		return this.http.get(`${settings.env.apiLoginUrl}v1/configuracoes/searchNomenclatura`);
	}
}